import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IPosition, IPositionInitialState } from "./positionModal";
import {
  ActiveInactivePosition,
  createPosition,
  deletePosition,
  getAllActivePosition,
  getAllPosition,
  getPositionByID,
  updatePosition,
} from "./services/position.services";

const initialState: IPositionInitialState = {
  loading: false,
  formLoading: false,
  error: "",
  PositionID: null,
  PositionList: [],
  PositionDetail: {
    ID: null,
    Title: "",
    IsActive: 1,
  },
};

const positionSlice = createSlice({
  name: "position",
  initialState,
  reducers: {
    clearPositionDetails: (state) => {
      state.PositionDetail = initialState.PositionDetail;
    },
    setPositionID: (state, action) => {
      state.PositionID = action.payload;
    },
    clearPositionID: (state) => {
      state.PositionID = initialState.PositionID;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getAllPosition.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(
      getAllPosition.fulfilled,
      (state, action: PayloadAction<IPosition[]>) => {
        state.loading = false;
        state.PositionList = action.payload || [];
      },
    );
    builder.addCase(getAllPosition.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
      state.PositionList = [];
    });
    builder.addCase(createPosition.pending, (state) => {
      state.formLoading = true;
      state.error = "";
    });
    builder.addCase(createPosition.fulfilled, (state) => {
      state.formLoading = false;
    });
    builder.addCase(createPosition.rejected, (state, action) => {
      state.formLoading = false;
      state.error = action.error.message || "Something went wrong";
    });
    builder.addCase(updatePosition.pending, (state) => {
      state.formLoading = true;
      state.error = "";
    });
    builder.addCase(updatePosition.fulfilled, (state) => {
      state.formLoading = false;
    });
    builder.addCase(updatePosition.rejected, (state, action) => {
      state.formLoading = false;
      state.error = action.error.message || "Something went wrong";
    });
    builder.addCase(deletePosition.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(deletePosition.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(deletePosition.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });
    builder.addCase(getPositionByID.pending, (state) => {
      state.formLoading = true;
      state.error = "";
    });
    builder.addCase(getPositionByID.fulfilled, (state, action: any) => {
      state.formLoading = false;
      state.PositionDetail = action.payload;
    });
    builder.addCase(getPositionByID.rejected, (state, action) => {
      state.formLoading = false;
      state.PositionDetail = initialState.PositionDetail;
      state.error = action.error.message || "Something went wrong";
    });
    builder.addCase(getAllActivePosition.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(
      getAllActivePosition.fulfilled,
      (state, action: PayloadAction<IPosition[]>) => {
        state.loading = false;
        state.PositionList = action.payload || [];
      },
    );
    builder.addCase(getAllActivePosition.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
      state.PositionList = [];
    });
    builder.addCase(ActiveInactivePosition.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(ActiveInactivePosition.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(ActiveInactivePosition.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });
  },
});

export const { clearPositionDetails, clearPositionID, setPositionID } =
  positionSlice.actions;
export default positionSlice.reducer;
